export const environment = {
  production: true,
  googleMapsApiKey : "AIzaSyBMWm_DHDcnKm4auze5vFFaiuAQdvtTrGE",
  azureWSBase: 'https://api.hub.test.ralarsa.com/AzureWS',
  baseWS: 'https://api.hub.test.ralarsa.com',
  miRlsWSBase: 'https://api.hub.test.ralarsa.com/miRlsWS',
  mailUri: 'https://test.ralarsa.com/wsRalarsa/public/index.php/office/enviaCorreo',
  msalRedirectUri: 'https://hub.test.ralarsa.com', 
  //msalRedirectUri: 'http://localhost:4200/',
  //callCenterWSBase: 'https://localhost:7037',
  callCenterWSBase: 'https://api.hub.test.ralarsa.com/CallcenterWS',
  tablasWSBase:"https://api.hub.test.ralarsa.com/TablasWS",
  clientesWSBase:"https://api.hub.test.ralarsa.com/ClientesWS",
  delegacionesWSBase:"https://api.hub.test.ralarsa.com/DelegacionesWS",
  articulosWSBase:"https://api.hub.test.ralarsa.com/ArticulosWS",
  externosWSBase:"https://api.hub.test.ralarsa.com/ExternoWS",
  hojaWSBase:"https://api.hub.test.ralarsa.com/HojasWS",
  googleWSBase:"https://api.hub.test.ralarsa.com/GoogleMapsWS",
  rlsWSBase: "https://api.hub.test.ralarsa.com/RlsWS",
  emailWSBase: "https://api.hub.test.ralarsa.com/EmailWS",
  logisticaWSBase: "https://api.hub.test.ralarsa.com/LogisticaWS",
  buscadorArticulo: "https://test.ralarsa.com/nou/",
  hubCallcenter:"https://hub.ralarsa.com/callcenter",
  bookingPlatformOrigin: "https://test-booking.carygroup.com",
  bookingPlataform: "https://test-booking.carygroup.com/ralarsa/cc/",
  mutuaWSBase:"https://api.hub.test.ralarsa.com/MutuaWS",
  glassTalleresWSBase:"https://api.hub.test.ralarsa.com/GlassTalleresWS",
  //glassTalleresWSBase:"https://localhost:7363",
  //constantes para la WebService de webralarsa Disponibilidad de horas
  wsDisponibilidadHorasURL:"https://localhost/wsRalarsa/public/index.php/webralarsa/disponibilidadhoras",
  wsDisponibilidadHorasParams:
    {
      token:"2!TBmPmp2&JlhPfrvTIzjiWWyCBS59t7ROhhhWEHi!M^!02ulA",
      user:"test",
      password:"testPassword",
      dia:"",
      tipo:0,
      delegacion:0,
    },
  wsRoleService:"https://api.hub.test.ralarsa.com/AplicacionesWebRoles/AplicacionesWeb",
  wsAuthExterno:"https://api.hub.test.ralarsa.com/AuthExternoWS/"

};
